<template>
  <div class="header">
    <div class="logo_wrap">
      <img :src="logo" alt="" />
    </div>
    <div class="nav_wrap">
      <ul>
        <router-link tag="li" :to="{path: '/index'}">
          <span>{{$t("mainNav.nIndex")}}</span>
        </router-link>
        <router-link tag="li" :to="{path: '/vip'}">
          <span>{{$t("mainNav.nVipCenter")}}</span>
        </router-link>
        <router-link tag="li" :to="{path: '/recharge'}">
          <span>{{$t("mainNav.nRecharge")}}</span>
        </router-link>
      </ul>
    </div>
    <div class="login_wrap" v-if="isShowLogin && !this.token">
      <ul class="">
        <router-link :to="{path: '/forget'}" tag="li">{{$t("userCenter.bForget")}}</router-link>
        <router-link :to="{path: '/register'}" tag="li">{{$t("userCenter.bRegister")}}</router-link>
        <li @click="login">{{$t("userCenter.bLogin")}}</li>
      </ul>
    </div>
    <div class="user_info" v-if="this.token && this.token.length>1">
      <span class="username">{{username}}</span>
      <span @click="logout"><img src="@/assets/images/logout-ico.png" alt=""></span>
    </div>
    <confirm :text="$t('userCenter.confirmLogout')" ref="confirmLogOut" :showCancel="true" :cancelBtnText="$t('userCenter.cancelText')" :confirmBtnText="$t('userCenter.confirmText')" @confirm="logOutBack"></confirm>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Confirm from "@/components/Confirm";

function isEmptyObject(obj) {
  for (var key in obj) {
    return false; //返回false，不为空对象
  }
  return true; //返回true，为空对象
}
export default {
  components: {
    Confirm
  },
  data() {
    return {
      isShowLogin: true
    };
  },
  computed: {
    username() {
      return isEmptyObject(this.user) ? '' : this.user.username
    },
    logo() {
      return this.$i18n.locale === 'th' ? require('@/assets/images/logo-th.png') : require('@/assets/images/logo.png')
    },
    ...mapGetters(["token", "user", 'uid'])
  },
  created() {
    this.showLoginOrNot();
  },
  methods: {
    login() {
      this.setLoginPopState(true);
    },
    showLoginOrNot() {
      if (this.$route.path === "/register") {
        this.isShowLogin = false;
      } else {
        this.isShowLogin = true;
      }
    },
    logout() {
      this.$refs.confirmLogOut.show();
    },
    logOutBack() {
      const data = {
        uid: this.uid
      }
      this.loginOut(data).then(res => {
        this.$parent.$refs.loginModule.clearMessage()
        this.$router.push({ path: "/index" });
        //this.$router.go(0)
      });
    },
    ...mapActions(["loginOut"]),
    ...mapMutations({
      setLoginPopState: "SET_LOGIN_POP_STATE"
    })
  },
  watch: {
    $route() {
      this.showLoginOrNot();
    }
  }
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import "@/assets/scss/variable.scss";
.header {
  width: 100%;
  height: 60px;
  background: #fbfcfe;
  color: #333;
  padding: 10px 25px;
  box-sizing: border-box;
  overflow: hidden;
  .logo_wrap {
    float: left;
    height: 35px;
    > img {
      height: 100%;
      vertical-align: middle;
    }
    h1 {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .nav_wrap {
    float: left;
    margin-left: 50px;
    height: 40px;
    > ul {
      overflow: hidden;
      > li {
        float: left;
        margin-left: 15px;
        line-height: 40px;
        font-size: 16px;
        padding: 0 15px;
        &.router-link-active {
          > span {
            color: $activeFont;
            border-bottom: 2px solid $activeFont;
          }
        }
        &:hover {
          > span {
            color: $activeFont;
          }
        }
        > span {
          cursor: pointer;
          color: $mainFont;
          font-weight: bold;
          padding-bottom: 3px;
        }
      }
    }
  }
  .login_wrap,
  .user_info {
    float: right;
    height: 40px;
    > ul {
      > li {
        float: right;
        line-height: 40px;
        font-size: 16px;
        margin-left: 15px;
        cursor: pointer;
        color: $mainFont;
        font-weight: bold;
      }
    }
    span {
      line-height: 40px;
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    }
    .username {
      margin-right: 5px;
      font-size: 14px;
      font-weight: bold;
      color: $mainFont;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue